module.exports = __webpack_public_path__ + "img/9.cc7cbf99.webp";